// extracted by mini-css-extract-plugin
module.exports = {"alert":"ip","alertIcon":"iq","formContainer":"ir","formContainerInner":"is","successIcon":"it","footer":"iu","footerItem":"iv"};